module.exports = __WEBPACK_EXTERNAL_MODULE_tabby_electron__;